window.theme = {
  
  init: () => {

    window.theme.sc_modal.init();
    window.theme.ic_modal.init();
    window.theme.product_custom_size.init();
    window.theme.product_shipping.init();
    window.theme.product_button_aria_label.init();
    window.wishlist.init();
    window.quiz.init();
    window.theme.gift_wrap_autoremove.init();
    window.theme.yagi.init();

  },

  product_custom_size: {
    
    submitButtonObservers: new Map(),
    resizeTimeout: null,
    
    init: () => {
      console.log('product_custom_size.init() called');
      window.theme.product_custom_size.initializeAll();
      window.theme.product_custom_size.initResizeObserver();
      
      // Watch for new product_form_wrapper elements (for quick-view)
      const observer = new MutationObserver((mutations) => {
        console.log('MutationObserver triggered, mutations:', mutations.length);
        mutations.forEach((mutation) => {
          console.log('Mutation:', mutation.type, 'addedNodes:', mutation.addedNodes.length);
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              console.log('Node added:', node.nodeName, node.className);
              
              // Check if the node or its descendants contain product_form_wrapper
              const wrappers = node.classList?.contains('product_form_wrapper') 
                ? [node] 
                : node.querySelectorAll?.('.product_form_wrapper') || [];
              
              console.log('Found wrappers:', wrappers.length);
              
              wrappers.forEach(wrapper => {
                console.log('Processing wrapper:', wrapper);
                const form = wrapper.querySelector('.product-form');
                const isInitialized = form?._customSizeInitialized || form?.classList.contains('custom-size-event');
                console.log('Form in wrapper:', form, 'already initialized:', isInitialized);
                
                if (form && !isInitialized) {
                  console.log('New product_form_wrapper detected, initializing...', wrapper);
                  // Ustaw flagę, żeby zapobiec wielokrotnej inicjalizacji
                  form._customSizeInitialized = true;
                  setTimeout(() => {
                    window.theme.product_custom_size.initializeContext(form);
                  }, 100);
                }
              });
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      console.log('MutationObserver set up and observing document.body');
    },

    initializeAll: () => {
      // Find all product forms
      const productForms = document.querySelectorAll('.product-form:not(.custom-size-event)');
      
      productForms.forEach((form) => {
        window.theme.product_custom_size.initializeContext(form);
      });
    },

    initializeContext: (form) => {
      const variantInput = form.querySelector('input[name="id"]');
      const sizeboxDropdowns = form.querySelector('.sizebox__dropdowns');
      const customSizeInputUser = form.querySelector('.custom_size_prop_name_for_user');
      
      // Find the product_form_wrapper parent
      const wrapper = form.closest('.product_form_wrapper');
      
      console.log('Initializing context for form:', form);
      console.log('Found wrapper:', wrapper);
      console.log('Found elements:', { variantInput, sizeboxDropdowns, customSizeInputUser });
      
      if (!variantInput || !sizeboxDropdowns || !customSizeInputUser || !wrapper) {
        console.warn('Missing required elements, skipping initialization');
        return;
      }

      // Skip if already initialized (sprawdź zarówno klasę jak i flagę)
      if (form.classList.contains('custom-size-event') && form._customSizesData) {
        console.log('Form already fully initialized with data, skipping');
        return;
      }

      // Get custom sizes data from wrapper's data-attribute
      const customSizesBase64 = wrapper.dataset.customSizes;
      console.log('Custom sizes base64 from data-attribute:', customSizesBase64);
      
      let customSizesData = [];
      if (customSizesBase64) {
        try {
          // Decode base64
          const customSizesJson = atob(customSizesBase64);
          console.log('Decoded JSON:', customSizesJson);
          
          customSizesData = JSON.parse(customSizesJson);
          console.log('Parsed custom sizes data:', customSizesData);
        } catch (e) {
          console.error('Failed to decode/parse custom sizes:', e, customSizesBase64);
        }
      }
      
      // Store data on the form element for later use
      form._customSizesData = customSizesData;

      // Add event listeners
      variantInput.addEventListener('change', function() {
        window.theme.product_custom_size.updateDropdownsInContext(form);
        setTimeout(() => {
          window.theme.product_custom_size.updateSubmitButtonInContext(form);
        }, 100);
        setTimeout(() => {
          window.theme.product_custom_size.updateSubmitButtonInContext(form);
        }, 2000);
      });

      document.addEventListener('variant:change', () => {
        window.theme.product_custom_size.updateDropdownsInContext(form);
        setTimeout(() => {
          window.theme.product_custom_size.updateSubmitButtonInContext(form);
        }, 100);
        setTimeout(() => {
          window.theme.product_custom_size.updateSubmitButtonInContext(form);
        }, 2000);
      });

      customSizeInputUser.addEventListener('input', function() {
        window.theme.product_custom_size.updateSubmitButtonInContext(form);
      });

      form.classList.add('custom-size-event');

      // Initialize submit button observer
      window.theme.product_custom_size.initSubmitButtonObserverInContext(form);

      // Generate initial dropdowns
      window.theme.product_custom_size.updateDropdownsInContext(form);
      window.theme.product_custom_size.updateSubmitButtonInContext(form);
    },

    initSubmitButtonObserverInContext: (form) => {
      const submitButton = form.querySelector('button[type="submit"]');
      
      if (!submitButton) {
        return;
      }

      // Use form as key for observer
      const formId = form.closest('[data-product-id]')?.dataset.productId || 'default';
      
      // Disconnect existing observer if any
      if (window.theme.product_custom_size.submitButtonObservers.has(formId)) {
        window.theme.product_custom_size.submitButtonObservers.get(formId).disconnect();
      }

      const observer = new MutationObserver(() => {
        window.theme.product_custom_size.updateSubmitButtonInContext(form);
      });
      
      observer.observe(submitButton, {
        attributes: true,
        attributeFilter: ['disabled']
      });

      window.theme.product_custom_size.submitButtonObservers.set(formId, observer);
    },

    initResizeObserver: () => {
      const updateDropdownWidths = () => {
        const sizeboxDropdowns = document.querySelectorAll('.sizebox__dropdown');
        
        sizeboxDropdowns.forEach(dropdown => {
          const toggle = dropdown.querySelector('.variant-picker-dropdown__toggle');
          const floatElement = dropdown.querySelector('.variant-picker-dropdown');
          
          if (toggle && floatElement) {
            const toggleWidth = toggle.offsetWidth;
            floatElement.style.maxWidth = toggleWidth + 'px';
          }
        });
      };

      // Initial update
      updateDropdownWidths();

      // Debounced resize handler
      window.addEventListener('resize', () => {
        clearTimeout(window.theme.product_custom_size.resizeTimeout);
        window.theme.product_custom_size.resizeTimeout = setTimeout(() => {
          updateDropdownWidths();
        }, 300);
      });
    },

    updateSubmitButtonInContext: (form) => {
      const customSizeInputUser = form.querySelector('.custom_size_prop_name_for_user');
      const customSizeInputHidden = form.querySelector('.custom_size_prop_name');
      const variantInput = form.querySelector('input[name="id"]');
      const submitButton = form.querySelector('button[type="submit"]');
      
      if (!customSizeInputUser || !customSizeInputHidden || !variantInput || !submitButton) {
        return;
      }

      // Get custom sizes data from form
      const customSizesData = form._customSizesData || [];
      
      const currentVariantId = parseInt(variantInput.value, 10);
      const variantData = customSizesData.find(item => item.variant_id === currentVariantId);
      
      // Check if variant has sizes and if custom size is selected
      const hasSizes = variantData && variantData.sizes && variantData.sizes.length > 0;
      const hasSelectedSize = customSizeInputUser.value.trim() !== '';
      
      // Get observer for this form
      const formId = form.closest('[data-product-id]')?.dataset.productId || 'default';
      const observer = window.theme.product_custom_size.submitButtonObservers.get(formId);
      
      // Temporarily disconnect observer to prevent infinite loop
      if (observer) {
        observer.disconnect();
      }
      
      if (hasSizes && !hasSelectedSize) {
        submitButton.setAttribute('disabled', 'disabled');
      } else {
        submitButton.removeAttribute('disabled');
      }
      
      // Reconnect observer
      if (observer && submitButton) {
        observer.observe(submitButton, {
          attributes: true,
          attributeFilter: ['disabled']
        });
      }
    },
    updateDropdownsInContext: (form) => {
      const sizeboxDropdowns = form.querySelector('.sizebox__dropdowns');
      const customSizeInputUser = form.querySelector('.custom_size_prop_name_for_user');
      const customSizeInputHidden = form.querySelector('.custom_size_prop_name');
      const variantInput = form.querySelector('input[name="id"]');
      
      console.log('updateDropdownsInContext called for form:', form);
      console.log('Found elements:', { sizeboxDropdowns, customSizeInputUser, customSizeInputHidden, variantInput });
      
      if (!sizeboxDropdowns || !customSizeInputUser || !customSizeInputHidden || !variantInput) {
        console.warn('Missing required elements in updateDropdownsInContext');
        return;
      }

      // Get custom sizes data from form (stored during initialization)
      const customSizesData = form._customSizesData || [];
      
      const currentVariantId = parseInt(variantInput.value, 10);
      const variantData = customSizesData.find(item => item.variant_id === currentVariantId);
      
      console.log('Current variant ID:', currentVariantId);
      console.log('Variant data:', variantData);
      console.log('All custom sizes for this form:', customSizesData);
      
      // Clear existing dropdowns
      sizeboxDropdowns.innerHTML = '';
      
      // Clear input values on variant change
      customSizeInputUser.value = '';
      customSizeInputHidden.value = '';
      
      if (!variantData || !variantData.sizes || variantData.sizes.length === 0) {
        return;
      }
      
      // Create dropdown for current variant
      const dropdownWrapper = document.createElement('div');
      dropdownWrapper.className = 'sizebox__dropdown is_active';
      
      const dropdownId = 'sizebox-dropdown-' + currentVariantId + '-' + Date.now();
      
      // Get current language for label
      const lang = document.documentElement.getAttribute('lang') || 'pl';
      const defaultSizeLabel = lang === 'en' ? 'Size' : 'Rozmiar';
      const selectLabel = lang === 'en' ? 'Select size' : 'Wybierz rozmiar';
      
      // Get custom label from data-label attribute or use default
      const sizeLabel = sizeboxDropdowns.dataset.label || defaultSizeLabel;
      
      // Generate dropdown items HTML
      const dropdownItemsHTML = variantData.sizes.map((size, index) => {
        const selectedClass = index === 0 ? ' selected' : '';
        return `<div class="variant-picker-dropdown__item${selectedClass}" tabindex="0" data-focus-trap-target="" data-size-value="${size}"><span>${size}</span></div>`;
      }).join('');
      
      dropdownWrapper.innerHTML = `
        <div class="" data-variant-picker-option-labels="" option-picker-name="${sizeLabel}">
          <div class="product-variant-picker__option-label">
            <span>${sizeLabel}</span>
          </div>
          <dropdown-opener class="variant-picker-dropdown__toggle variant-picker-dropdown__toggle--outline" 
            data-aria-expanded="false" 
            data-float-element-id="${dropdownId}" 
            data-trigger="click" 
            tabindex="0">
            <div class="variant-picker-dropdown__toggle-label" data-dropdown-variant-picker-label="">
              <span>${selectLabel}</span>
            </div>
            <svg class="variant-picker-dropdown__chevron" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="title" role="img">
              <title id="title">Chevron</title>
              <path d="M9.5 7L14.5 12L9.5 17" stroke="currentColor" stroke-width="2"></path>
            </svg>
          </dropdown-opener>
          <div class="variant-picker-dropdown custom-size-dropdown" 
            aria-hidden="true" 
            id="${dropdownId}" 
            data-placement="bottom-start" 
            data-main-axis-offset="0">
            <div class="variant-picker-dropdown__body">${dropdownItemsHTML}</div>
          </div>
        </div>
      `;
      
      sizeboxDropdowns.appendChild(dropdownWrapper);
      
      // Update dropdown width after appending
      setTimeout(() => {
        const toggle = dropdownWrapper.querySelector('.variant-picker-dropdown__toggle');
        const floatEl = dropdownWrapper.querySelector('.variant-picker-dropdown');
        
        if (toggle && floatEl) {
          const toggleWidth = toggle.offsetWidth;
          floatEl.style.maxWidth = toggleWidth + 'px';
        }
      }, 0);
      
      // Add click handlers for size options
      const sizeOptions = dropdownWrapper.querySelectorAll('.variant-picker-dropdown__item');
      const toggleLabel = dropdownWrapper.querySelector('[data-dropdown-variant-picker-label] span');
      const dropdownOpener = dropdownWrapper.querySelector('dropdown-opener');
      const floatEl = dropdownWrapper.querySelector('.custom-size-dropdown');
      
      sizeOptions.forEach(option => {
        option.addEventListener('click', function() {
          const selectedSize = this.dataset.sizeValue;
          
          // Update both inputs
          if (customSizeInputUser) {
            customSizeInputUser.value = selectedSize;
          }
          if (customSizeInputHidden) {
            customSizeInputHidden.value = selectedSize;
          }
          
          // Remove selected class from all options
          sizeOptions.forEach(opt => opt.classList.remove('selected'));
          // Add selected class to clicked option
          this.classList.add('selected');
          
          if (toggleLabel) {
            toggleLabel.textContent = selectedSize;
          }
          
          // Update submit button state
          window.theme.product_custom_size.updateSubmitButtonInContext(form);
          
          // Close dropdown
          if (dropdownOpener) {
            dropdownOpener.setAttribute('data-aria-expanded', 'false');
          }
          if (floatEl) {
            floatEl.setAttribute('aria-hidden', 'true');
          }
        });
      });
      
      // Add toggle functionality to dropdown opener
      if (dropdownOpener && floatEl) {
        dropdownOpener.addEventListener('click', function() {
          const isExpanded = this.getAttribute('data-aria-expanded') === 'true';
          this.setAttribute('data-aria-expanded', !isExpanded);
          floatEl.setAttribute('aria-hidden', isExpanded);
        });
      }
    }

  },

  product_shipping: {

    init: () => {
      window.theme.product_shipping.addListeners();
    },

    addListeners: () => {
      const productForms = document.querySelectorAll('.product-form:not(.shipping-event)');
      
      if (!productForms.length) {
        return;
      }

      productForms.forEach((form) => {
        const variantInput = form.querySelector('input[name="id"]');
        const shippingTimeEl = document.querySelector('.shipping_time');
        
        if (!variantInput || !shippingTimeEl) {
          return;
        }

        window.theme.product_shipping.updateShippingTimeClass(variantInput, shippingTimeEl);

        variantInput.addEventListener('change', function() {
          // console.log('Variant changed to:', this.value);
          window.theme.product_shipping.updateShippingTimeClass(variantInput, shippingTimeEl);
        });

        document.addEventListener('variant:change', () => {
          // console.log(`Variant changed (event) to:`, variantInput.value);
          window.theme.product_shipping.updateShippingTimeClass(variantInput, shippingTimeEl);
        });

        form.classList.add('shipping-event');
      });
    },

    updateShippingTimeClass: (variantInput, shippingTimeEl) => {
      const currentVariantId = parseInt(variantInput.value, 10);
      
      // Parse shipping config from data attribute - MUST be at the top
      const shippingConfig = {};
      const configStr = shippingTimeEl.dataset.shippingConfig || '';
      
      let defaultTime = '';
      let langIndex = 0;
      
      // Helper to decode base64 with UTF-8 support
      function decodeBase64UTF8(str) {
        try {
          if (!str) return '';
          return decodeURIComponent(escape(atob(str)));
        } catch(e) {
          console.error('Failed to decode base64 UTF-8:', e);
          return '';
        }
      }
      
      try {
        defaultTime = shippingTimeEl.dataset.shippingDefault ? decodeBase64UTF8(shippingTimeEl.dataset.shippingDefault) : '';
      } catch(e) {
        console.error('Failed to decode shippingDefault:', e);
      }
      
      try {
        langIndex = parseInt(atob(shippingTimeEl.dataset.langIndex || 'MA=='), 10);
      } catch(e) {
        console.error('Failed to decode langIndex:', e);
        langIndex = 0;
      }
      
      // Helper function to handleize strings (must match Liquid handleize and inventory parser)
      function handleize(str) {
        return str
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }
      
      if (configStr) {
        try {
          // Decode base64 with UTF-8 support
          const decodedConfig = decodeBase64UTF8(configStr);
          const entries = decodedConfig.split('||').filter(e => e.trim());
          entries.forEach(entry => {
            const [location, timePl, timeEn] = entry.split('::');
            if (location && timePl && timeEn) {
              // Use handleized location key to match inventory data format
              const locationKey = handleize(location);
              shippingConfig[locationKey] = {
                pl: timePl,
                en: timeEn
              };
            }
          });
        } catch(e) {
          console.error('Failed to decode or parse shipping config:', e);
        }
      }
      
      // Check if custom shipping time is set (from metafield)
      const customValueEl = shippingTimeEl.querySelector('.shipping_time__value--custom');
      if (customValueEl && customValueEl.textContent.trim() !== '') {
        shippingTimeEl.classList.remove('shipping_time--internal', 'shipping_time--external');
        shippingTimeEl.classList.add('shipping_time--custom');
        return;
      }
      
      const variantData = window.product_inventory_data.find(
        item => item.variant_id === currentVariantId
      );

      // console.log('variantData:', variantData);
      // console.log('shippingConfig:', shippingConfig);
      
      if (!variantData) {
        // console.log('No inventory data for variant:', currentVariantId);
        const externalValueEl = shippingTimeEl.querySelector('.shipping_time__value--external');
        const langKey = langIndex === 1 ? 'en' : 'pl';
        let shippingTimeText = defaultTime;
        
        // Try to get vendor from DOM
        const vendorEl = document.querySelector('.product-general-info-block__vendor');
        if (vendorEl) {
          const vendorName = vendorEl.textContent.trim();
          const vendorHandleized = handleize(vendorName);
          
          // console.log('Vendor from DOM:', vendorName, '-> handleized:', vendorHandleized);
          
          if (vendorHandleized && shippingConfig[vendorHandleized]) {
            shippingTimeText = shippingConfig[vendorHandleized][langKey];
            // console.log('Using vendor shipping time:', shippingTimeText);
          }
        }
        
        // If no vendor match, use default time
        if (shippingTimeText === defaultTime) {
          console.log('Setting default shipping time:', defaultTime);
        }
        
        if (externalValueEl) {
          externalValueEl.textContent = shippingTimeText;
        }
        
        shippingTimeEl.classList.remove('shipping_time--internal', 'shipping_time--custom');
        shippingTimeEl.classList.add('shipping_time--external');
        return;
      }
      
      const equishopInventory = variantData.locations.equishop || 0;
      
      const externalValueEl = shippingTimeEl.querySelector('.shipping_time__value--external');
      
      // Priority 1: Check Equishop inventory
      if (equishopInventory > 0) {
        shippingTimeEl.classList.remove('shipping_time--external', 'shipping_time--custom');
        shippingTimeEl.classList.add('shipping_time--internal');
        document.querySelector('.product-form__btns').classList.add('product-form__btns--shipping-internal');
        return;
      }
      
      // Priority 2: Find location with highest inventory
      let maxInventory = 0;
      let maxLocation = null;
      
      for (const [locationKey, inventory] of Object.entries(variantData.locations)) {
        if (locationKey !== 'equishop' && inventory > maxInventory) {
          maxInventory = inventory;
          maxLocation = locationKey;
        }
      }
      
      // Priority 3: If max inventory found, use shipping time for that location
      let shippingTimeText = defaultTime;
      const langKey = langIndex === 1 ? 'en' : 'pl';

      // console.log('shippingConfig', shippingConfig);
      
      if (maxInventory > 0 && maxLocation && shippingConfig[maxLocation]) {
        shippingTimeText = shippingConfig[maxLocation][langKey];
      } else if (maxInventory === 0) {
        // Priority 3.5: All locations have 0 inventory - try to match vendor with shipping_time config
        const vendorHandleized = variantData.vendor || '';
        
        if (vendorHandleized && shippingConfig[vendorHandleized]) {
          shippingTimeText = shippingConfig[vendorHandleized][langKey];
        }
        // If no vendor match, shippingTimeText stays as defaultTime
      }
      
      if (externalValueEl) {
        externalValueEl.textContent = shippingTimeText;
      }
      
      shippingTimeEl.classList.remove('shipping_time--internal', 'shipping_time--custom');
      shippingTimeEl.classList.add('shipping_time--external');
    }

  },

  product_button_aria_label: {

    observers: [],

    init: () => {
      window.theme.product_button_aria_label.addListeners();
      window.theme.product_button_aria_label.observeButtons();
    },

    addListeners: () => {
      const productForms = document.querySelectorAll('.product-form:not(.aria-label-event)');
      
      if (!productForms.length) {
        return;
      }

      productForms.forEach((form) => {
        const variantInput = form.querySelector('input[name="id"]');
        
        if (!variantInput) {
          return;
        }

        variantInput.addEventListener('change', function() {
          window.theme.product_button_aria_label.updateButtonAriaLabel(form);
        });

        document.addEventListener('variant:change', () => {
          window.theme.product_button_aria_label.updateButtonAriaLabel(form);
        });

        form.classList.add('aria-label-event');
      });
    },

    observeButtons: () => {
      const submitButtons = document.querySelectorAll('.product-form__btn');
      
      if (!submitButtons.length) {
        return;
      }

      submitButtons.forEach((button) => {
        const observer = new MutationObserver(() => {
          const form = button.closest('.product-form');
          if (form) {
            window.theme.product_button_aria_label.updateButtonAriaLabel(form);
          }
        });

        observer.observe(button, {
          attributes: true,
          attributeFilter: ['disabled']
        });

        window.theme.product_button_aria_label.observers.push(observer);
      });
    },

    updateButtonAriaLabel: (form) => {
      const submitButtons = form.querySelectorAll('.product-form__btn');
      
      if (!submitButtons.length) {
        return;
      }

      submitButtons.forEach((button) => {
        const isDisabled = button.hasAttribute('disabled');
        
        let ariaLabel = '';
        
        if (isDisabled) {
          ariaLabel = button.getAttribute('data-t-sold-out') || 'Wyprzedane';
        } else {
          const buttonTextSpan = button.querySelector('[data-button-text]');
          if (buttonTextSpan) {
            ariaLabel = buttonTextSpan.textContent.trim();
          }
        }
        
        if (ariaLabel) {
          button.setAttribute('aria-label', ariaLabel);
        }
      });
    }

  },

  sc_modal: {

    init: () => {
      window.theme.sc_modal.addListeners();
    },

    addListeners: () => {

      const btns_open = document.querySelectorAll('[data-action="open_sc_modal"]:not(.event)');
      if (btns_open.length) {
        btns_open.forEach((btn) => {
          btn.addEventListener('click', () => {
            window.theme.sc_modal.open();
          });
          btn.classList.add('event');
        });
      }

      const btns_close = document.querySelectorAll('.sc_modal__close:not(.event)');
      if (btns_close.length) {
        btns_close.forEach((btn) => {
          btn.addEventListener('click', () => {
            window.theme.sc_modal.close();
          });
          btn.classList.add('event');
        });
      }

    },

    open: () => {
      document.body.classList.add('sc_modal_is_open');
    },

    close: () => {
      document.body.classList.remove('sc_modal_is_open');
    }

  },

  ic_modal: {

    init: () => {
      window.theme.ic_modal.addListeners();
    },

    addListeners: () => {

      const btns_open = document.querySelectorAll('[data-action="open_ic_modal"]:not(.event)');
      if (btns_open.length) {
        btns_open.forEach((btn) => {
          btn.addEventListener('click', () => {
            window.theme.ic_modal.open();
          });
          btn.classList.add('event');
        });
      }

      const btns_close = document.querySelectorAll('.ic_modal__close:not(.event)');
      if (btns_close.length) {
        btns_close.forEach((btn) => {
          btn.addEventListener('click', () => {
            window.theme.ic_modal.close();
          });
          btn.classList.add('event');
        });
      }

    },

    open: () => {
      document.body.classList.add('ic_modal_is_open');
    },

    close: () => {
      document.body.classList.remove('ic_modal_is_open');
    }

  },

  gift_wrap_autoremove: {

    init: () => {
      const giftVid = document.body.dataset.giftVid;
      
      if (!giftVid) {
        return;
      }

      window.theme.gift_wrap_autoremove.checkCart();

      if (window.gift_wrap_autoremove_interval) {
        clearInterval(window.gift_wrap_autoremove_interval);
        window.gift_wrap_autoremove_interval = null;
      }

      window.gift_wrap_autoremove_interval = setInterval(() => {
        window.theme.gift_wrap_autoremove.checkCart();
      }, 500);
    },

    checkCart: async () => {
      const giftVid = document.body.dataset.giftVid;
      
      if (!giftVid || window.gift_wrap_removing_in_progress) {
        return;
      }

      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        if (!cart || !cart.items || cart.items.length === 0) {
          return;
        }

        // Find gift wrap item by variant ID
        const giftWrapItem = cart.items.find(item => {
          return item.variant_id === parseInt(giftVid, 10);
        });

        if (!giftWrapItem) {
          return;
        }

        // Check if there are other items besides gift wrap
        const otherItems = cart.items.filter(item => item.key !== giftWrapItem.key);

        if (otherItems.length === 0) {
          // Only gift wrap in cart - remove it
          await window.theme.gift_wrap_autoremove.removeGiftWrap(giftWrapItem.key);
        }
      } catch (error) {
        console.error('Error checking cart for gift wrap:', error);
      }
    },

    removeGiftWrap: async (itemKey) => {
      if (window.gift_wrap_removing_in_progress) {
        return;
      }

      window.gift_wrap_removing_in_progress = true;

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: 0
          })
        });

        if (response.ok) {
          console.log('Gift wrap removed from cart');
          
          // Refresh cart UI
          const cartPage = document.querySelector('cart-page');
          const cartDrawer = document.querySelector('cart-drawer');
          
          if (cartPage && window.gift_wrap && typeof window.gift_wrap.refreshCartPage === 'function') {
            window.gift_wrap.refreshCartPage();
          } else if (cartDrawer && window.gift_wrap && typeof window.gift_wrap.refreshCartDrawer === 'function') {
            window.gift_wrap.refreshCartDrawer();
          }
          
          // Trigger cart update events
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }, 200);
        }
      } catch (error) {
        console.error('Error removing gift wrap:', error);
      } finally {
        window.gift_wrap_removing_in_progress = false;
      }
    }
  },

  yagi: {
    init: () => {
      window.theme.yagi.checkProductCards();
      window.theme.yagi.checkProductPage();
    },

    checkProductCards: () => {
      const productCards = document.querySelectorAll('product-card');
      
      productCards.forEach(card => {
        const yagiDiscountedPrice = card.querySelector('.yagi-discounted-price');
        const productCardPrice = card.querySelector('.product-card__price');
        
        if (yagiDiscountedPrice && productCardPrice) {
          productCardPrice.classList.add('product-card__price--hidden_by_yagi');
        }
      });
    },

    checkProductPage: () => {
      const productPage = document.querySelector('.product__info');
      
      if (!productPage) {
        return;
      }
      
      const yagiDiscountedPrice = productPage.querySelector('.yagi-discounted-price');
      const productPrice = productPage.querySelector('.product__content .product-price');
      
      if (yagiDiscountedPrice && productPrice) {
        productPrice.classList.add('product-price--hidden_by_yagi');
      }
    }
  }
};


window.wishlist = {
  
  init: () => {
    const wishlistContainer = document.getElementById('th_wishlist_page_id');
    if (wishlistContainer) {
      window.wishlist.translateTexts();
    }

    const successMessage = document.getElementById('th-wl-sucess-mgs');
    if (successMessage && successMessage.textContent.includes('|||')) {
      window.wishlist.translateElement(successMessage);
    }

    window.wishlist.observeChanges();
    window.wishlist.count();
    window.wishlist.observeLazyLoadedProducts();
  },

  observeLazyLoadedProducts: () => {

    const observer = new MutationObserver((mutations) => {
      let hasNewWishlistButtons = false;

      try {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
              if (!node || node.nodeType !== Node.ELEMENT_NODE) {
                return;
              }

              if (node.classList && (
                  node.classList.contains('th_wl_col_btn') || 
                  node.classList.contains('th_prd_wl_btn') || 
                  node.classList.contains('th_wl_btn')
                )) {
                hasNewWishlistButtons = true;
              }

              if (node.querySelectorAll) {
                try {
                  const wishlistButtons = node.querySelectorAll('.th_wl_col_btn, .th_prd_wl_btn, .th_wl_btn');
                  if (wishlistButtons && wishlistButtons.length > 0) {
                    hasNewWishlistButtons = true;
                  }
                } catch (e) {
                  console.warn('Błąd podczas wyszukiwania przycisków wishlisty:', e);
                }
              }
            });
          }
        });

        if (hasNewWishlistButtons) {
          if (typeof window.$th_refreshWishlistItems === 'function') {
            try {
              window.$th_refreshWishlistItems();
            } catch (e) {
              console.error('Błąd podczas odświeżania wishlisty:', e);
            }
          } else {
            console.warn('Funkcja window.$th_refreshWishlistItems nie jest jeszcze dostępna');
          }
          
          if (typeof window.$th_refreshBackInStockItems === 'function') {
            try {
              window.$th_refreshBackInStockItems();
            } catch (e) {
              console.error('Błąd podczas odświeżania Back In Stock:', e);
            }
          }
        }
      } catch (error) {
        console.error('Błąd w obserwatorze wishlisty:', error);
      }
    });

    try {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

    } catch (error) {
      console.error('Nie udało się uruchomić obserwatora wishlisty:', error);
    }
  },

  count: () => {
    if (window.wishlist_count_interval) {
      clearInterval(window.wishlist_count_interval);
      window.wishlist_count_interval = null;
    }

    const updateCountFromStorage = () => {
      const raw = localStorage.getItem('th_wlc_pro_count');
      let count = parseInt(raw, 10);
      if (Number.isNaN(count) || count < 0) count = 0;

      const els = document.querySelectorAll('.wishlist_count');
      els.forEach(el => {
        el.setAttribute('data-items-number', String(count));
        const span = el.querySelector('span');
        if (span) span.textContent = count > 0 ? String(count) : '';
      });
    };

    updateCountFromStorage();

    window.wishlist_count_interval = setInterval(() => {
      updateCountFromStorage();
    }, 500);
  },

  observeChanges: () => {
    const mainObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              
              if (node.id === 'th-wl-sucess-mgs') {
                // console.log('Znaleziono komunikat sukcesu:', node.textContent);
                if (node.textContent.includes('|||')) {
                  window.wishlist.translateElement(node);
                }
                return;
              }

              const successMessageInside = node.querySelector && node.querySelector('#th-wl-sucess-mgs');
              if (successMessageInside && successMessageInside.textContent.includes('|||')) {
                // console.log('Znaleziono komunikat sukcesu wewnątrz:', successMessageInside.textContent);
                window.wishlist.translateElement(successMessageInside);
                return;
              }

              if (node.textContent && node.textContent.includes('|||')) {
                // console.log('Znaleziono węzeł z |||:', node.textContent);
                window.wishlist.translateElement(node);
              }
            }
          });
        }

        if (mutation.type === 'characterData' && mutation.target.textContent.includes('|||')) {
          // console.log('Zmiana tekstu z |||:', mutation.target.textContent);
          const parentElement = mutation.target.parentElement;
          if (parentElement) {
            window.wishlist.translateElement(parentElement);
          }
        }
      });
    });

    mainObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    const wishlistContainer = document.getElementById('th_wishlist_page_id');
    if (wishlistContainer) {
      const wishlistObserver = new MutationObserver(() => {
        setTimeout(() => {
          const container = document.getElementById('th_wishlist_page_id');
          if (container && container.innerHTML.includes('|||')) {
            container.classList.remove('translated');
            window.wishlist.translateTexts();
          }
        }, 100);
      });

      wishlistObserver.observe(wishlistContainer, {
        childList: true,
        subtree: true
      });
    }
  },

  translateTexts: () => {
    const lang = document.documentElement.getAttribute('lang') || 'pl';
    const isEnglish = lang === 'en';
    
    const wishlistContainer = document.getElementById('th_wishlist_page_id');
    if (!wishlistContainer) return;

    const processText = (text) => {
      if (text.includes('|||')) {
        const parts = text.split('|||');
        return isEnglish ? (parts[1] || parts[0]).trim() : parts[0].trim();
      }
      return text;
    };

    const walker = document.createTreeWalker(
      wishlistContainer,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      if (node.textContent.includes('|||')) {
        textNodes.push(node);
      }
    }

    textNodes.forEach(textNode => {
      textNode.textContent = processText(textNode.textContent);
    });

    const elementsWithAttributes = wishlistContainer.querySelectorAll('*');
    elementsWithAttributes.forEach(element => {
      const attributesToCheck = ['title', 'alt', 'placeholder', 'data-title', 'aria-label'];
      
      attributesToCheck.forEach(attr => {
        const value = element.getAttribute(attr);
        if (value && value.includes('|||')) {
          element.setAttribute(attr, processText(value));
        }
      });
    });

    const successMessage = document.getElementById('th-wl-sucess-mgs');
    if (successMessage) {
      window.wishlist.translateElement(successMessage);
    }

    setTimeout(() => {
      wishlistContainer.classList.add('translated');
    }, 300);
  },

  translateElement: (element) => {
    if (!element) return;
    
    const lang = document.documentElement.getAttribute('lang') || 'pl';
    const isEnglish = lang === 'en';
    
    const processText = (text) => {
      if (text.includes('|||')) {
        const parts = text.split('|||');
        return isEnglish ? (parts[1] || parts[0]).trim() : parts[0].trim();
      }
      return text;
    };

    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      if (node.textContent.includes('|||')) {
        textNodes.push(node);
      }
    }

    textNodes.forEach(textNode => {
      textNode.textContent = processText(textNode.textContent);
    });

    const elementsWithAttributes = element.querySelectorAll('*');
    elementsWithAttributes.forEach(el => {
      const attributesToCheck = ['title', 'alt', 'placeholder', 'data-title', 'aria-label'];
      
      attributesToCheck.forEach(attr => {
        const value = el.getAttribute(attr);
        if (value && value.includes('|||')) {
          el.setAttribute(attr, processText(value));
        }
      });
    });

    const attributesToCheck = ['title', 'alt', 'placeholder', 'data-title', 'aria-label'];
    attributesToCheck.forEach(attr => {
      const value = element.getAttribute(attr);
      if (value && value.includes('|||')) {
        element.setAttribute(attr, processText(value));
      }
    });
  }
};


window.quiz = {

  translations: {
    "pl": {
      "back": "Wstecz",
      "next": "Dalej",
      "add to cart": "Dodaj do koszyka",
      "submit": "Wyślij",
      "skip": "Pomiń",
      "This field can't be empty": "To pole nie może być puste"
    }
  },

  init: () => {
    const quiz_section = document.querySelector('[data-quiz-kit-key]');

    if (quiz_section) {
      window.quiz.translateTexts(quiz_section);

      setTimeout(() => {
        window.quiz.translateTexts(quiz_section);
      }, 500);
    }
    
    window.quiz.observeChanges();
  },

  translateText: (text, lang = null) => {
    if (!lang) {
      lang = document.documentElement.getAttribute('lang') || 'pl';
    }

    const trimmedText = text.trim();

    if (!window.quiz.translations[lang]) {
      return text;
    }

    if (window.quiz.translations[lang][trimmedText]) {
      return window.quiz.translations[lang][trimmedText];
    }

    const lowerText = trimmedText.toLowerCase();
    const translationKeys = Object.keys(window.quiz.translations[lang]);
    
    for (let key of translationKeys) {
      if (key.toLowerCase() === lowerText) {
        return window.quiz.translations[lang][key];
      }
    }

    return text;
  },

  translateTexts: (container) => {
    if (!container) return;

    const lang = document.documentElement.getAttribute('lang') || 'pl';
    // console.log('Translating quiz to language:', lang);

    const walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      if (node.textContent.trim()) {
        textNodes.push(node);
      }
    }

    textNodes.forEach(textNode => {
      const originalText = textNode.textContent;
      const trimmedText = originalText.trim();
      const translatedText = window.quiz.translateText(trimmedText, lang);
      
      if (translatedText !== trimmedText) {
        const leadingWhitespace = originalText.match(/^\s*/)[0];
        const trailingWhitespace = originalText.match(/\s*$/)[0];
        textNode.textContent = leadingWhitespace + translatedText + trailingWhitespace;
        // console.log(`Translated "${trimmedText}" to "${translatedText}"`);
      }
    });

    const elementsWithAttributes = container.querySelectorAll('*');
    const attributesToTranslate = ['title', 'placeholder', 'aria-label', 'alt', 'data-title'];
    
    elementsWithAttributes.forEach(element => {
      attributesToTranslate.forEach(attr => {
        const value = element.getAttribute(attr);
        if (value) {
          const translatedValue = window.quiz.translateText(value.trim(), lang);
          if (translatedValue !== value.trim()) {
            element.setAttribute(attr, translatedValue);
            // console.log(`Translated attribute ${attr}: "${value}" to "${translatedValue}"`);
          }
        }
      });
    });
  },

  observeChanges: () => {
    const quiz_section = document.querySelector('[data-quiz-kit-key]');
    
    if (!quiz_section) {
      // console.log('Quiz section not found, observer not started');
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // console.log('New node added to quiz, translating...');
              window.quiz.translateTexts(node);
            }
          });
        }

        if (mutation.type === 'characterData') {
          const parentElement = mutation.target.parentElement;
          if (parentElement) {
            // console.log('Text content changed in quiz, translating...');
            window.quiz.translateTexts(parentElement);
          }
        }
      });
    });

    observer.observe(quiz_section, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: false
    });
  }
};


window.theme.init();


(function() {
  const origFetch = window.fetch;

  window.fetch = async function(...args) {
    const [url, options] = args;

    if (typeof url === 'string' && url.includes('/cart/add')) {

      try {
        const response = await origFetch.apply(this, args);

        if (response.ok) {
          const data = await response.clone().json();
          const product_info = document.querySelector('[data-set-max-quantity-to-1="1"] product-info');
          const matched_product_cards = document.querySelectorAll(`product-card[data-variant-id="${data.variant_id}"]`);

          if (product_info) {
            const html = product_info.innerHTML;
            const regex = new RegExp(`["']?${data.variant_id}["']?`);
            if (regex.test(html)) {
              const product_qty = document.querySelector('[data-set-max-quantity-to-1="1"] product-info .product-quantity__wrap');
              if (product_qty) {
                product_qty.classList.add('hide_max_qty_item_block');
              }

              const product_form = document.querySelector('[data-set-max-quantity-to-1="1"] product-info product-form');
              if (product_form) {
                product_form.classList.add('hide_max_qty_item_block');
              }
            }
          }
          
          if (matched_product_cards.length) {
            matched_product_cards.forEach((item)=> {
              item.classList.add('product-card--hide-actions');
            });
          }

          window.dispatchEvent(new CustomEvent('addToCart:success', { detail: data }));
        } else {
          console.warn('⚠️ Add to cart failed:', response.status, response.statusText);
        }

        return response;
      } catch (err) {
        console.error('❌ Fetch /cart/add error:', err);
        throw err;
      }
    }

    return origFetch.apply(this, args);
  };
})();
